import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Column } from "@appcues/component-library";
import TrialMeterPanel from "components/Subscription/TrialMeterPanel";
import SubscriptionPicker from "components/SubscriptionPicker";

import { selectAccountMeta } from "reducers/account/meta";
import { selectOverviewAnalytics } from "reducers/analytics";
import { fetchOverviewAnalytics } from "actions/analytics";

export class FreeTrial extends Component {
  componentDidMount() {
    const {
      actions: { fetchOverviewAnalytics }
    } = this.props;
    fetchOverviewAnalytics();
  }
  render() {
    const { meta, overviewAnalytics } = this.props;
    const { isInstalled, flowsShownLimit, createdAt, trialLengthDays } = meta;

    const normalizedFlowsShown =
      overviewAnalytics &&
      overviewAnalytics.data &&
      overviewAnalytics.data.flows_shown
        ? overviewAnalytics.data.flows_shown
        : 0;

    return (
      <Column alignItems="stretch">
        <TrialMeterPanel
          createdAt={createdAt}
          flowsShown={normalizedFlowsShown}
          flowsShownLimit={flowsShownLimit}
          isInstalled={isInstalled}
          trialLengthDays={trialLengthDays}
        />
        <SubscriptionPicker />
      </Column>
    );
  }
}

const mapStateToProps = state => {
  const meta = selectAccountMeta(state);
  const overviewAnalytics = selectOverviewAnalytics(state);

  return {
    overviewAnalytics,
    meta
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({ fetchOverviewAnalytics }, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FreeTrial);
